__turbopack_context__.v({
  "flipping-icon": "styles-module__iqhWYa__flipping-icon",
  "header-text": "styles-module__iqhWYa__header-text",
});
